import React from 'react';

// Replaces the old For-VC-firms / For-portfolio-companies tab switcher. The two "effects on returns"
// that used to be their own section are now the blue closing line on each stage card.
const STAGES = [
    { num: '01', title: '360° view at application', body: 'Every applicant gets a free Diligentsia account. Governance gaps, IP issues, and documentation holes surface automatically before your analysts spend serious time.', effect: '→ Fewer bad investments: risks visible at week one, not week twelve.' },
    { num: '02', title: 'Preliminary DD before IC', body: 'Concurrent corporate readiness alongside your market evaluation. Series A compressed from 10–30 weeks to 6–15 weeks. ~£25,000 saved (mid-scenario).', effect: '→ Avoiding your worst two investments in ten does more for returns than any other single lever.' },
    { num: '03', title: 'Always on post-investment', body: 'Portfolio companies stay on platform. Governance stays clean. Unified dashboard for portfolio managers. Every next round or exit starts from a position of strength.', effect: '→ Higher exit valuations: a maintained Diligence Pack removes the buyer’s excuse to chip price.' },
];

const VCStagesSection = () => (
    <section className="lp-stages-section">
        <div className="lp-stages-inner">
            <div className="lp-stages-head">
                <h2 className="lp-h2" data-lp-reveal style={{ fontWeight: '600' }}>Three stages. Two effects on returns.</h2>
                <p className="lp-sub" data-lp-reveal data-lp-delay="80" style={{ maxWidth: '700px' }}>From first application to portfolio exit — always working, and each stage pays for itself.</p>
            </div>

            <div className="lp-stages-grid">
                {STAGES.map((s, i) => (
                    <div key={s.num} className="lp-stage-card" data-lp-reveal data-lp-delay={i * 90}>
                        <div className="lp-stage-num">{s.num}</div>
                        <h4 className='w100'>{s.title}</h4>
                        <p>{s.body}</p>
                        <span className="lp-stage-effect">{s.effect}</span>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default VCStagesSection;
